import React from "react";
import NodePorts from "./NodePorts";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography } from "@material-ui/core";
import { CheckCircle } from "@material-ui/icons";

/**
 * Cerrar ticket (0422 M2). Terminal: sin conector de salida, igual que el salto a otro flujo —
 * un ticket cerrado no debe seguir recibiendo mensajes del bot.
 */
const useStyles = makeStyles((theme) => ({
  nodeContainer: {
    minWidth: 200,
    maxWidth: 280,
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    background: "linear-gradient(135deg, #43a047 0%, #66bb6a 100%)",
    border: "2px solid #43a047",
    color: "white",
    position: "relative",
    transition: "all 0.2s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 6px 16px rgba(67, 160, 71, 0.5)",
    },
  },
  nodeHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
  nodeIcon: {
    fontSize: 20,
  },
  nodeLabel: {
    fontWeight: 600,
    fontSize: 14,
    color: "white",
  },
  nodeContent: {
    fontSize: 12,
    opacity: 0.95,
    marginTop: theme.spacing(0.5),
    padding: theme.spacing(1),
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    borderRadius: 8,
    whiteSpace: "pre-wrap",
  },
}));

const CloseTicketNode = ({ data, selected }) => {
  const classes = useStyles();
  const aviso = String(data?.message || "").trim();

  return (
    <Box
      className={classes.nodeContainer}
      style={{
        boxShadow: selected
          ? "0 6px 20px rgba(67, 160, 71, 0.6)"
          : "0 4px 12px rgba(67, 160, 71, 0.4)",
      }}
    >
      <NodePorts color="#43a047" salida={false} />
      <Box className={classes.nodeHeader}>
        <CheckCircle className={classes.nodeIcon} />
        <Typography className={classes.nodeLabel}>Cerrar ticket</Typography>
      </Box>
      <Box className={classes.nodeContent}>
        {aviso ? (aviso.length > 60 ? `${aviso.substring(0, 60)}...` : aviso) : "Cierra sin aviso"}
      </Box>
    </Box>
  );
};

export default CloseTicketNode;
